import MeteoHome from './[locality]';

export default MeteoHome;
